import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'po-button-spinner',
  templateUrl: 'button-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonSpinnerComponent {}
